export const videoLazyLoading = function() {
    const videoTargetObserver = document.querySelectorAll('.video-container') ;
    const options = {
      root: null,
      threshold: 0,
      rootMargin: '-300px'
    };

    const videoLazyLoadingObserver = new IntersectionObserver(entries => {
      entries.forEach( async video => {
        const sourceApplied = video.target.querySelector('source');
        const videoSourceUrl = sourceApplied.getAttribute('src');
        if (video.isIntersecting && videoSourceUrl === '') {
          sourceApplied.setAttribute('src', sourceApplied.dataset.videoUrl);
          video.target.autoplay = true;
          video.target.load();
          video.target.play();
        }
      });
    }, options);

  if(videoTargetObserver) {
    videoTargetObserver.forEach(videoContainer => {
      videoLazyLoadingObserver.observe(videoContainer)
    })
  }
}
